<template>
  <transition name="fade">
    <div class="ui-dialog">
      <div class="ui-dialog__overlay" @click="$emit('close')"></div>
      <div class="ui-dialog__content">
        <div class="mdl-dialog__content align--center">
          <file-upload @fileUploadSuccess="$emit('fileUploadSuccess')" />
        </div>
        <div class="mdl-dialog__actions align--center">
          <button
            type="button"
            class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import FileUpload from './FileUpload'

export default {
  name: 'addDocument',
  components: { FileUpload }
}
</script>
